import React, {useEffect, useState} from 'react';
import useMediaQuery from "@mui/system/useMediaQuery";
import {CircularProgress, Typography, useTheme} from "@mui/joy";
import Dialog from "@mui/material/Dialog";
import {BasicModalContent} from "@dreebit-registry/vsm-microservice-components";
import {resolveErrorMessage} from "../../utils/resolveErrorMessage";
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "@apollo/client";
import {toast} from "react-toastify";
import _ from "lodash";
import {Box} from "@mui/system";
import {CreateInstalledBaseNodeAttribute} from "../../graphql/mutations/createInstalledBaseNodeAttribute";
import {InstalledBaseNodeAttributeListTDAs} from "../../graphql/queries/installedBaseNodeAttributeListTDAs";
import InstalledBaseTDAForm from "../InstalledBaseTDAForm";


interface Props {
    open: boolean,
    onClose?: () => void,
}

const CreateAttributeModal = ({onClose, open}: Props) => {
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const {t} = useTranslation();

    const [propertyType, setPropertyType] = useState("INSTALLED_BASE_NODE");
    const [createAttributeMutation] = useMutation(CreateInstalledBaseNodeAttribute);

    const {data, loading, refetch} = useQuery(InstalledBaseNodeAttributeListTDAs, {
        variables: {
            typeDefinitionIndex: "PROPERTY_DEFINITION_CREATE",
            options: {
                propertyType: propertyType
            }
        },
        fetchPolicy: "network-only",
    })

    // Refetch attributes when propertyType changes
    useEffect(() => {
        if (open) {
            refetch({
                typeDefinitionIndex: "PROPERTY_DEFINITION_CREATE",
                options: {
                    propertyType: propertyType
                }
            });
        }
    }, [propertyType, open, refetch]);

    const handleSubmit = (input: any) => {
        return createAttributeMutation({
                variables: {
                    input: input
                },
                refetchQueries: ["InstalledBaseNodeAttributeList"]
            }
        ).then((res) => {
            if (res.data?.createInstalledBaseNodePropertyDefinition?.id && res.data?.createInstalledBaseNodePropertyDefinition?.preferredName) {
                toast.success(`${t("Successfully created attribute")} ${res.data?.createInstalledBaseNodePropertyDefinition?.preferredName}`);
            } else {
                toast.error(t("Error creating attribute."))
            }
            if (onClose) {
                onClose();
            }
        }).catch((err) => {
            toast.error(resolveErrorMessage(err, t))
        })
    }

    const attributes = _.get(data, 'installedBaseNodePropertyDefinitionList.typeDefinitionAttributeList.typeDefinitionAttributes', [])

    return  <Dialog open={open} onClose={onClose} fullScreen={isFullScreen}>
        <BasicModalContent onClose={onClose} title={<Typography level={'titleSmallLight'}>{t('Create new attribute')}</Typography>}>
            <Box sx={{ minHeight: '300px', position: 'relative' }}>
                {loading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <InstalledBaseTDAForm
                        key={propertyType}
                        formStyle={{paddingTop: '0px'}}
                        onSubmit={handleSubmit}
                        onCancel={onClose}
                        submitButtonText={t('Create')}
                        attributes={attributes}
                        enableReinitialize={true}
                        onValuesChange={(values) => {
                            if (values.propertyType && values.propertyType !== propertyType) {
                                setPropertyType(values.propertyType);
                            }
                        }}
                    />
                )}
            </Box>
        </BasicModalContent>
    </Dialog>
};

export default CreateAttributeModal;
